import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { apiAttendanceForParentGet$Json } from 'amoxcalli-academic-api';

import { environment } from '../../../../environments/environment';
import { AsistenciaActions } from './asistencia.actions';

@Injectable()
export class AsistenciaEffects {
  private readonly actions$ = inject(Actions);
  private readonly http     = inject(HttpClient);

  loadAsistencia$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AsistenciaActions.loadAsistencia),
      switchMap(({ studentId }) =>
        apiAttendanceForParentGet$Json(this.http, environment.serverUrl.academic, { studentId }).pipe(
          map((response) => {
            const registros = (response.body ?? [])
              .map((dto) => ({
                id:     dto.id ?? '',
                fecha:  dto.fecha ?? '',
                status: dto.status ?? 0,
              }))
              .sort((a, b) => b.fecha.localeCompare(a.fecha));
            return AsistenciaActions.loadAsistenciaSuccess({ registros });
          }),
          catchError(() =>
            of(AsistenciaActions.loadAsistenciaFailure({ error: 'No se pudo cargar la asistencia.' }))
          )
        )
      )
    )
  );
}
